export default __webpack_public_path__ + "static/media/axe.4c395483.png";